// form-consent-handler

let formsWithRecaptcha = []

function checkForRecaptcha() {
    const replacementHtml = document.getElementById('site-settings-consent-required-message').innerHTML
    const forms = document.querySelectorAll('form.cmpt-form-wrapper');
    forms.forEach(form => {
        const recaptchaDiv = form.querySelector('div[id^="google-recaptcha"]');
        if (recaptchaDiv) {
            formsWithRecaptcha.push(form);
            const replacementNode = document.createElement('div');
            replacementNode.classList.add('consent-required-form-replacement');
            replacementNode.innerHTML = replacementHtml;
            replacementNode.style.display = 'none';
            form.insertAdjacentElement('afterEnd', replacementNode);
        }
    });
}

function getCookieValue(name) {
    return parseCookieValue(document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1]);
}

function parseCookieValue(cookieValue) {
    if(cookieValue) {
        return Object.fromEntries(
            cookieValue.split(',').map(part => part.split(':').map(decodeURIComponent))
        );
    }
    return;
}

function hideForm(form) {
    form.style.display = 'none';

    var replacement = form.parentNode.querySelector('.consent-required-form-replacement');
    if (replacement) {
        replacement.style.display = 'block';
    }
}

function showForm(form) {
    form.style.display = 'block';

    var replacement = form.parentNode.querySelector('.consent-required-form-replacement');
    if (replacement) {
        replacement.style.display = 'none';
    }
}

function handleForms(forms, shouldShowForm) {
    forms.forEach(form => {
            if(shouldShowForm) {
                showForm(form);
            } else {
                hideForm(form);
            }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    checkForRecaptcha();

    if(formsWithRecaptcha.length == 0) return;

    document.addEventListener('cookieyes_consent_update', (eventData) => {
        const data = eventData.detail;
        handleForms(formsWithRecaptcha, data.accepted.includes("analytics"));
    });

    const maxAttempts = 20;
    let attempts = 0;
    
    const interval = setInterval(() => {
        attempts++;
        const cookieValue = getCookieValue('cookieyes-consent');
        if (cookieValue || attempts >= maxAttempts) {
            clearInterval(interval);
            if (cookieValue) {
                handleForms(formsWithRecaptcha, cookieValue.consent ==='no'); // no means they have consented
            }
        }
    }, 100);
});
